var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-left primary white--text pl-2 py-2 text-uppercase",staticStyle:{"font-size":"0.875rem","font-weight":"500"}},[_vm._v(_vm._s(_vm.barLabel))]),_c('highcharts',{attrs:{"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }